const STORAGE_KEY = 'aliyah_wishlist_v1';
const EMAIL_GIVEN_KEY = 'aliyah_wishlist_email_given_v1';
const POPUP_SKIPPED_KEY = 'aliyah_wishlist_popup_skipped_v1';
export const WISHLIST_UPDATED_EVENT = 'wishlist:updated';

export function getWishlist(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

export function isInWishlist(productId: string): boolean {
  return getWishlist().includes(productId);
}

function persist(ids: string[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  window.dispatchEvent(new CustomEvent(WISHLIST_UPDATED_EVENT, { detail: { count: ids.length } }));
}

/** Ajoute ou retire le produit — retourne `true` si ajouté, `false` si retiré. */
export function toggleWishlistItem(productId: string): boolean {
  const ids = getWishlist();
  const index = ids.indexOf(productId);

  if (index === -1) {
    persist([...ids, productId]);
    return true;
  }

  persist(ids.filter((id) => id !== productId));
  return false;
}

export function removeFromWishlist(productId: string): void {
  persist(getWishlist().filter((id) => id !== productId));
}

/** L'email n'est jamais redemandé une fois connu — peu importe la popup ou le
 * formulaire de /liste-de-souhaits qui l'a capturé. */
export function hasWishlistEmail(): boolean {
  try {
    return localStorage.getItem(EMAIL_GIVEN_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setWishlistEmailGiven(): void {
  try {
    localStorage.setItem(EMAIL_GIVEN_KEY, 'true');
  } catch {
    // localStorage indisponible (navigation privée, quota…) — tant pis, on
    // redemandera l'email la prochaine fois, sans bloquer l'ajout aux favoris.
  }
}

/** Popup wishlist fermée sans email (croix, clic sur le fond, Échap) — ne plus la
 * reproposer ensuite sur les cœurs suivants. Distinct de `hasWishlistEmail` : ce
 * flag ne dit rien sur si un email a réellement été capturé, seulement qu'on ne
 * doit plus interrompre — le formulaire de /liste-de-souhaits reste, lui, toujours
 * proposé indépendamment de ce choix. */
export function hasSkippedWishlistPopup(): boolean {
  try {
    return localStorage.getItem(POPUP_SKIPPED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setWishlistPopupSkipped(): void {
  try {
    localStorage.setItem(POPUP_SKIPPED_KEY, 'true');
  } catch {
    // idem hasWishlistEmail — tant pis, elle pourra se reproposer.
  }
}
